export const STATUS = {
  RUNNING: 'RUNNING',
  WAITING: 'WAITING',
  CERTIFIED: 'CERTIFIED',
  FORBID: 'FORBID'
};
export const SHOP_STATE = {
  WAITING: 'WAITING',
  AUTHENTICATION_FAILED: 'AUTHENTICATION_FAILED',
  VIOLATION_HALT_SALE: 'VIOLATION_HALT_SALE',
  VIOLATION_HALT_FAILED: 'VIOLATION_HALT_FAILED',
  VIOLATION_HALT_WAITING: 'VIOLATION_HALT_WAITING',
  CERTIFIED: 'CERTIFIED',
  DESTROYED: 'DESTROYED'
};
export const SHOP_STATE_zh = {
  WAITING: '待审核',
  AUTHENTICATION_FAILED: '开店审核失败',
  VIOLATION_HALT_SALE: '整改中',
  VIOLATION_HALT_FAILED: '整改审核失败',
  VIOLATION_HALT_WAITING: '整改待审核',
  CERTIFIED: '经营中',
  DESTROYED: '注销'
};
